import { useIsProjectTeamsEnabled } from ':cloud/hooks/featureFlags/useIsProjectTeamsEnabled';
import { ProjectRoleNEW } from ':cloud/types/service_proto';
import { OrganizationRole } from ':cloud/types/ts_types';

import Permission from './Permission';
import PermissionProject from './PermissionProject';

// Role mapping
const ROLE_MAP: Record<OrganizationRole, ProjectRoleNEW> = {
  ROLE_OWNER: ProjectRoleNEW.Owner,
  ROLE_ADMIN: ProjectRoleNEW.Admin,
  ROLE_USER: ProjectRoleNEW.UserNEW,
};

// Helper to convert org roles to project roles
function convertRole(
  role: OrganizationRole | OrganizationRole[],
): ProjectRoleNEW | ProjectRoleNEW[] {
  if (Array.isArray(role)) {
    return role.map((r) => ROLE_MAP[r]);
  }
  return ROLE_MAP[role];
}

function PermissionWrapper(props: any) {
  const isProjectTeamsEnabled = useIsProjectTeamsEnabled();

  if (isProjectTeamsEnabled) {
    // Convert the role(s) if they're org roles
    const convertedPermission =
      typeof props.permission === 'string' || Array.isArray(props.permission)
        ? convertRole(props.permission)
        : props.permission;

    return <PermissionProject {...props} permission={convertedPermission} />;
  }

  return <Permission {...props} />;
}

export default PermissionWrapper;
